<template>
  <div class="life_costs-pages-paySuccessPage" id="life_costs-pages-paySuccessPage">
    <div class="container-scroll">
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-result
          status="success"
          title="支付中！"
        >
          <template #extra>
            <div class="paySuccess-detail">
              <div class="detailitem">
                  <span>订单号：</span>
                  <span>{{orderId}}</span>
              </div>
              <div class="detailitem">
                  <span>订单时间：</span>
                  <span>{{orderTime}}</span>
              </div>
              <div class="detailitem" v-if="false">
                  <span>支付完成时间：</span>
                  <span>{{pavedTime}}</span>
              </div>
              <div class="detailitem">
                  <span>订单金额：</span>
                  <span>{{amount}}</span>
              </div>
              <div class="detailitem">
                  <span>订单状态：</span>
                  <span>{{status}}</span>
              </div>
              <div class="detailitem">
                  <span>账户类型：</span>
                  <span>{{accuntType}}</span>
              </div>
            </div>
          </template>
        </a-result>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  //这里必须 使用一个方法返回给data
  data () {
    return {
      orderId:"",     //订单号
      orderTime:"",     //订单时间
      pavedTime:"",     //支付完成时间
      amount:"",     //订单金额
      status:"",     //订单状态
      accuntType:"",     //账户类型
    }
  },
  mounted() {
    let kRouter = this.$route.query;
    this.orderId = decodeURI(kRouter.orderId);
    this.orderTime = decodeURI(kRouter.orderTime);
    this.pavedTime = decodeURI(kRouter.pavedTime);
    this.amount = decodeURI(kRouter.amount);
    this.status = decodeURI(kRouter.status);
    this.accuntType = decodeURI(kRouter.accuntType);
  },
  watch: {},

  computed: {},
  methods: {

  }  
}
</script>

<style scoped>
.life_costs-pages-paySuccessPage .paySuccess-top {
  padding: 26px;
  box-sizing: border-box;
  text-align: center;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px dotted #DFDFDF; }
  .life_costs-pages-paySuccessPage .paySuccess-top h1 {
    font-size: 28px; }
  .life_costs-pages-paySuccessPage .paySuccess-top .cabin-font-icon {
    margin-bottom: 20px; }
    .life_costs-pages-paySuccessPage .paySuccess-top .cabin-font-icon.iconsty {
      font-size: 90px;
      color: #33be66; }

.life_costs-pages-paySuccessPage .paySuccess-detail {
  padding: 20px 0 20px 80px;
  box-sizing: border-box;
  position: relative;
  width: 300px;
  margin: 0 auto; 
  text-align: left;
  }
  .life_costs-pages-paySuccessPage .paySuccess-detail .detailitem {
    margin-bottom: 10px; }

</style>